import { serialize } from './kql';
import { withSearchTerm } from './kqlBuilder';
import { cardPagePath } from './cards';

/** The grouped search of a collection: `/collections/:id/search?q=<term>` (KPR-355). */
export function collectionSearchPath(collectionId, term = '') {
	const base = `/collections/${collectionId}/search`;
	const trimmed = `${term || ''}`.trim();
	return trimmed ? `${base}?${new URLSearchParams({ q: trimmed }).toString()}` : base;
}

/**
 * "See all N" on a card's group: the collection's list for THAT card and the
 * same term. The card goes as `card=<id>`, which the list sends as the exact
 * `card_id`, never as KQL `card = <key>`: the KQL form includes the card's
 * child cards and would show more rows than the group's count (KPR-744). The
 * term goes where the list's own search box keeps it, as the `q` condition
 * `text ~ "term"`.
 */
export function seeAllPath(collectionId, cardId, term) {
	const params = new URLSearchParams();
	if (cardId) params.set('card', cardId);
	const ast = withSearchTerm(null, term, 'text');
	if (ast) params.set('q', serialize(ast));
	const search = params.toString();
	return `/collections/${collectionId}/items${search ? `?${search}` : ''}`;
}

/** A found item's page, in the collection the item lives in (a sub-collection's, for a family search). */
export function foundItemPath(item, fallbackCollectionId) {
	return `/collections/${item?.collectionId || fallbackCollectionId}/items/${item?.id}`;
}

/** A found card's page, with this collection in hand (a global card needs one). */
export function foundCardPath(cardId, collectionId) {
	return cardPagePath(cardId, collectionId);
}

/** What the server matched an item by, as a phrase: "name, notes, tag Urgent". */
export function evidenceSentence(matchedIn = []) {
	const parts = [];
	(Array.isArray(matchedIn) ? matchedIn : []).forEach((entry) => {
		let part = '';
		if (entry?.kind === 'notes') part = 'notes';
		else if (entry?.kind === 'tag') part = entry.name ? `tag ${entry.name}` : 'a tag';
		else if (entry?.name) part = entry.name;
		if (part && !parts.includes(part)) parts.push(part);
	});
	return parts.join(', ');
}
